import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyMaskDirective } from './currency-mask.directive';
import { DontPasteDirective } from './dont-paste.directive';
import { OnlyLettersDirective } from './only-letters.directive';
import { OnlyNumbersDirective } from './only-numbers.directive';
import { CapitalizeDirective } from './capitalize.directive';
import { SelectOverlayPositionDirective } from './select-overlay-position.directive';
import { DayLimitDirective } from './day-limit.directive';
import { NotStartZeroDirective } from './not-start-zero.directive';
import { AddressDirective } from './address.directive';
import { MoreThanTwoLettersDirective } from './more-than-two-letters.directive';
import { OnlyLettersWithApostropheDirective } from './only-letters-with-apostrophe.directive';
import { CompanyNameDirective } from './company-name.directive';

@NgModule({
  declarations: [
    CurrencyMaskDirective,
    DontPasteDirective,
    OnlyLettersDirective,
    OnlyNumbersDirective,
    CapitalizeDirective,
    SelectOverlayPositionDirective,
    DayLimitDirective,
    NotStartZeroDirective,
    AddressDirective,
    MoreThanTwoLettersDirective,
    OnlyLettersWithApostropheDirective,
    CompanyNameDirective
  ],
  imports: [CommonModule],
  exports: [
    CurrencyMaskDirective,
    DontPasteDirective,
    OnlyLettersDirective,
    OnlyNumbersDirective,
    CapitalizeDirective,
    DayLimitDirective,
    NotStartZeroDirective,
    SelectOverlayPositionDirective,
    AddressDirective,
    MoreThanTwoLettersDirective,
    OnlyLettersWithApostropheDirective,
    CompanyNameDirective
  ]
})
export class DirectivesModule {}
